module.exports = __webpack_public_path__ + "img/overseas_5.48cceba3.jpg";